'use client';

import type { FallbackProps } from 'react-error-boundary';

import { IS_DEV } from '@/constants';

type ErrorFallbackProps = FallbackProps & {
  message?: string;
  showRetry?: boolean;
  resetErrorBoundary: VoidFunction;
};

const ErrorFallback = ({
  error,
  resetErrorBoundary,
  message = '일시적인 오류가 발생했습니다.',
  showRetry = true,
}: ErrorFallbackProps) => {
  return (
    <div
      className="flex w-full flex-col items-center justify-center gap-20 px-24 py-60"
      role="alert"
      aria-live="assertive"
    >
      <div className="flex flex-col items-center gap-8 text-center">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="24" cy="24" r="20" fill="#FFE8E8" />
          <path
            d="M24 14V26M24 32V34"
            stroke="#FF4800"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
        <p className="font-600 text-Gray-900 typo-body3">{message}</p>
        {IS_DEV && (
          <p className="max-w-[300px] break-words font-400 text-Gray-600 typo-caption1">
            {error.message}
          </p>
        )}
      </div>
      {showRetry && (
        <button
          onClick={resetErrorBoundary}
          className="rounded-medium bg-O-500 px-20 py-12 font-700 text-Gray-white transition-colors typo-body3 hover:bg-O-600 active:bg-O-700"
          type="button"
        >
          다시 시도
        </button>
      )}
    </div>
  );
};

export const ChallengeErrorFallback = (props: FallbackProps) => (
  <section className="flex w-full flex-col items-center bg-Y-50 px-24 py-60">
    <ErrorFallback
      {...props}
      message="챌린지 정보를 불러오는 중 문제가 발생했습니다."
    />
  </section>
);

export const StampMapErrorFallback = (props: FallbackProps) => (
  <section className="flex w-full flex-col items-center bg-B-25 px-24 py-60">
    <ErrorFallback
      {...props}
      message="스탬프 맵 정보를 불러오는 중 문제가 발생했습니다."
    />
  </section>
);

export const MyGiftErrorFallback = (props: FallbackProps) => (
  <section className="flex w-full flex-col items-center bg-Y-50 px-24 py-60">
    <ErrorFallback
      {...props}
      message="답례품 정보를 불러오는 중 문제가 발생했습니다."
    />
  </section>
);
